import { render, staticRenderFns } from "./SelectSala.vue?vue&type=template&id=99ed7bb8"
import script from "./SelectSala.vue?vue&type=script&lang=js"
export * from "./SelectSala.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports